
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'TCOSI',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TCOSI.vue